import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

const eventTypes = [
    'Trail Run (single or multi day)',
    'BaseCamp (campout)',
    'Meetup',
    'Volunteer Event'
];

const eventOptions = eventTypes.map(event => ({ value: event, label: event }));

const EventTypeSelect = ({ value, onChange }) => {
    const handleChange = useCallback((selected) => {
        if (selected) {
            onChange({ target: { value: selected.value } });
        }
    }, [onChange]);

    const selectedOption = useMemo(() => {
        return eventOptions.find(opt => opt.value === value) || null;
    }, [value]);

    return (
        <div style={{ marginBottom: '1rem' }}>
            <label className="block mb-1 text-sm font-bold">Event Type</label>
            <Select
                options={eventOptions}
                value={selectedOption}
                onChange={handleChange}
                placeholder="Select an event type"
                isSearchable
                key="event-type-select"
            />
        </div>
    );
};

export default EventTypeSelect;